import {css} from "@emotion/css";

import {designColors} from "~/ui";

export const styles = {
  whiteButton: (error?: boolean) => css`
    &.MuiButton-root {
      &,
      &:hover,
      &:active {
        color: ${designColors.black};
        border: 1px solid ${designColors.grey_3};
        box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.1);

        ${error &&
        css`
          color: ${designColors.error};
          border: 1px solid ${designColors.error};
        `}
      }
      &.Mui-focusVisible {
        border: 1px solid ${designColors.blue_3};
        box-shadow:
          0px 2px 0px 0px rgba(0, 0, 0, 0.1),
          inset 0 0 0 1px ${designColors.blue_3};
      }
      &.Mui-disabled,
      &.MuiLoadingButton-root.Mui-disabled {
        color: ${designColors.colorInk};
        background-color: ${designColors.white};

        border: none;
        box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.1);
        opacity: 0.4;
      }
    }

    & .MuiLoadingButton-loadingIndicator {
      color: ${designColors.colorInk};
    }

    & .MuiTouchRipple-root span {
      background-color: ${designColors.white};
      border-radius: 50%;

      opacity: 1 !important;
    }
  `,
  active: (active?: boolean) =>
    active &&
    css`
      &.MuiButton-root {
        border: 1.5px solid ${designColors.blue_2};
        background-color: ${designColors.blue_1};
      }
    `,
};
